import { useQuery } from 'react-query';

import { GetSubsetsResponseDto } from '../../../../backend/src/matter/subset/dto/get-subsets.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';
import { Case } from '@/types';

export type CaseWithDocCount = Case & { docCount: number };

const ONE_HOUR_MS = 60 * 60 * 1000;

/** Check if any subset is processing and was created within the last hour (ignores stuck/bugged subsets). */
export const hasRecentProcessingSubset = (subsets: GetSubsetsResponseDto[] | undefined): boolean =>
  subsets?.some((s) => s.status === 'processing' && new Date(s.createdDate).getTime() > Date.now() - ONE_HOUR_MS) ??
  false;

export const useGetSubsets = (matterId: string | null) => {
  const fetcher = useFetcher();

  return useQuery<GetSubsetsResponseDto[]>(
    [QueryEntity.Subsets, { matterId }],
    () => fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset`),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!matterId,
      // Poll every 3 seconds if any subset is processing
      refetchInterval: (data) => {
        const hasProcessing = data?.some((subset) => subset.status === 'processing');
        return hasProcessing ? 3000 : false;
      },
    },
  );
};
